import Vue from 'vue'
import configs from '@/config'
import { logInfo } from '@/3rd-parties/sentry'

let resource = null

const actions = {
  createOrUpdateAudience: {
    method: 'POST',
    url: `${configs.baseUrl}/api/audiences/`,
  },
  getAudienceData: {
    method: 'GET',
    url: `${configs.baseUrl}/api/audiences/audience-data`,
  },
  getAudienceDataCDN: {
    method: 'GET',
    url: `${configs.baseUrl}/api/presentation/audience-data/{uniqueAccessCode}`,
  },
  audienceJoinPresentation: {
    method: 'POST',
    url: configs.api.joinPresentation,
  },
}

const initResource = () => {
  resource = Vue.resource('', {}, actions)
}

const createOrUpdateAudience = async (payload) => {
  logInfo('create/update audience', payload)
  const res = await resource.createOrUpdateAudience(payload)
  return res.body
}

const getAudienceData = async (payload) => {
  const res = await resource.getAudienceData(payload)
  return res.body
}

const getAudienceDataCDN = async (uniqueAccessCode, payload = null) => {
  return resource.getAudienceDataCDN({ uniqueAccessCode }, payload)
}

const audienceJoinPresentation = async (payload) => {
  const res = await resource.audienceJoinPresentation(payload)
  return res.body
}

export default {
  initResource,
  createOrUpdateAudience,
  getAudienceData,
  getAudienceDataCDN,
  audienceJoinPresentation,
}
